module.exports = __webpack_public_path__ + "img/remove.3e0c7d0e.svg";